import React from 'react';
import { connect } from 'react-redux';
import CanvasJSChart from '../CanvasJSChart';
import LoadingControl from '../../../LoadingControl';

class PieChart extends React.Component {
    render() {
        const { propId, dataPoints, colors } = this.props;
        if (!dataPoints || !Array.isArray(dataPoints))
            return (<LoadingControl />);

        const orange = '#FF9538';
        const green = '#49C2CB';
        const purple = '#AE83E2';
        const greenTwo = '#49CB85';
        const red = '#F93B74';
        const grey = '#D1DDE1';
        const greenThree = '#00B252';
        const redTwo = '#CE0025';
        const greenFour = '#049346';

        let colorsSet = colors ? colors : [orange, green, purple, greenTwo, red, grey, greenThree, redTwo, greenFour];

        const dataPointsToUse = dataPoints.map(dataPoint => {
            return {
                label: dataPoint.label,
                y: dataPoint.value,
                color: dataPoint.color
            };
        });

        const options = {
            colorSet: 'Zacoustic',
            animationEnabled: true,
            theme: 'light1', // "light1", "light2", "dark1", "dark2"
            animationEnabled: true,
            legend: {
                fontSize: 14,
                fontFamily: 'Roboto',
                fontWeight: 400,
            },
            data: [
                {
                    type: 'pie',
                    showInLegend: true,
                    legendText: "{label}",
                    indexLabel: "{y}%",
                    indexLabelPlacement: "inside",
                    indexLabelFontSize: 16,
                    indexLabelFontWeight: 400,
                    indexLabelFontFamily: 'Roboto',
                    indexLabelFontColor: "black",
                    startAngle: 0,
                    dataPoints: dataPointsToUse
                }
            ]
        };

        return (
            <CanvasJSChart
                chartContainerId={propId}
                options={options}
                containerProps={{ height: '100%', width: '100%' }}
                colorSet={colorsSet}
            />
        );
    }
}

const select = state => ({ ...state.session });

export default connect(select)(PieChart);
